@if(isDisabled){
<app-loader></app-loader>
}
<form name="ModuleLockForm" (ngSubmit)="Save(ModuleLockForm)" #ModuleLockForm="ngForm">
    <div class="card">
        <div class="card-header">
            Module Lock
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-md-4">
                    <label>Module <span class="text-danger">*</span></label>
                    <ng-select name="module" placeholder="Select Module" [items]="ModuleLoad" bindLabel="ModuleName"
                        bindValue="WebESSModuleMasterID" [(ngModel)]="Filter.WEBESSModuleMasterId" #module="ngModel" (change)="ESS_ModuleLockConfigurationSelect(Filter.WEBESSModuleMasterId)"
                        required>
                    </ng-select>
                </div>
                <div class="col-md-3">
                    <label class="Label">From Date <span class="text-danger">*</span></label>
                    <div class="input-group" style="height: auto;">
                        <input class="form-control" name="DateFrom" placeholder="Ex. DD MMM YYYY" ngbDatepicker
                            #d="ngbDatepicker" [(ngModel)]="Filter.FromDate" #DateFrom="ngModel" required />
                        <button class="btn btn-outline-secondary bi bi-calendar3" (click)="d.toggle()"
                            type="button"></button>
                    </div>
                </div>

                <div class="col-md-3">
                    <label class="Label">To Date <span class="text-danger">*</span></label>
                    <div class="input-group" style="height: auto;">
                        <input class="form-control" name="DateTo" placeholder="Ex. DD MMM YYYY" ngbDatepicker
                            #d3="ngbDatepicker" [(ngModel)]="Filter.ToDate" #DateTo="ngModel" required />
                        <button class="btn btn-outline-secondary bi bi-calendar3" (click)="d3.toggle()"
                            type="button"></button>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <label for="message" class="for-label">Remark <span class="text-danger">*</span></label>
                    <input [(ngModel)]="Filter.Message" type="text" class="form-control" id="message" name="message"
                        #message="ngModel" placeholer="Remark" required>
                </div>
                <div class="col-md-auto mt-1"><br>
                    <label style="font-size: 14px;">Restrict
                        for Admin</label>&nbsp;&nbsp;
                    <input class="form-check-input" style="height: 15px; width: 15px;" name="filter" type="checkbox"
                        [(ngModel)]="Filter.IsRestrictedForAdmin" />
                </div>
                <div class="col-md-auto">
                    <button type="submit" class="btn btn-primary btn-sm mt-4"> <i
                            class="bi bi-save me-1"></i>Save</button>
                </div>
            </div>
            <hr>
            <div>
                <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger" class="table table-bordered pt-2"
                    style="width: 100%; overflow: auto;">
                    <thead class="table-light">
                        <tr>
                            <th style="width: 5px;">#</th>
                            <th>Action</th>
                            <th>Module Name</th>
                            <th>From Date</th>
                            <th>To Date</th>
                            <th>Admin Restricted</th>
                            <th>Remark</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let element of TableData ;let i = index">
                            <th scope="row">{{ i + 1 }}</th>
                            <td>
                                <div style="display: flex; align-items: center; justify-content: center">
                                    <i (click)="onEdit(element)" class="bi bi-pencil-square text-warning me-3"></i>
                                    <i (click)="Delete(element)"
                                        class="bi bi-trash text-danger"></i>
                                </div>
                            </td>
                            <td> {{element['ModuleName']}}</td>
                            <td> {{element['FromDate']}}</td>
                            <td> {{element['ToDate']}}</td>
                            <td> {{element['IsRestrictedforAdmin'] ? 'Yes': 'No'}}</td>
                            <td> {{element['Message']}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</form>